export default {
  redirectTo (url) {
    window.location.assign(url)
  }
}
